var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("header", [
      _c("div", { staticClass: "header" }, [
        _c(
          "div",
          { staticClass: "header-left" },
          [
            _c(
              "router-link",
              { staticClass: "logo", attrs: { to: "/index" } },
              [_c("img", { attrs: { src: _vm.logo, height: "40", alt: "" } })]
            )
          ],
          1
        ),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "page-title-box" }, [
          _c("h3", [
            _vm._v(_vm._s(_vm.appTitle) + " "),
            _c("span", { staticStyle: { "font-size": "12px" } }, [
              _vm._v("vBeta")
            ])
          ])
        ]),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("ul", { staticClass: "nav user-menu" }, [
          false
            ? _c("li", { staticClass: "nav-item dropdown" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "dropdown-menu notifications" }, [
                  _vm._m(3),
                  _vm._v(" "),
                  _c("div", { staticClass: "noti-content" }, [
                    _c("ul", { staticClass: "notification-list" }, [
                      _c(
                        "li",
                        { staticClass: "notification-message" },
                        [
                          _c("router-link", { attrs: { to: "/activities" } }, [
                            _c("div", { staticClass: "media" }, [
                              _c("span", { staticClass: "avatar" }, [
                                _c("img", {
                                  attrs: {
                                    alt: "",
                                    src: require("../../assets/profiles/avatar-02.jpg")
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "media-body" }, [
                                _c("p", { staticClass: "noti-details" }, [
                                  _c("span", { staticClass: "noti-title" }, [
                                    _vm._v("John Doe")
                                  ]),
                                  _vm._v(
                                    " added new task\n                          "
                                  ),
                                  _c("span", { staticClass: "noti-title" }, [
                                    _vm._v("Patient appointment booking")
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "noti-time" }, [
                                  _c(
                                    "span",
                                    { staticClass: "notification-time" },
                                    [_vm._v("4 mins ago")]
                                  )
                                ])
                              ])
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "notification-message" },
                        [
                          _c("router-link", { attrs: { to: "/activities" } }, [
                            _c("div", { staticClass: "media" }, [
                              _c("span", { staticClass: "avatar" }, [
                                _c("img", {
                                  attrs: {
                                    alt: "",
                                    src: require("../../assets/profiles/avatar-03.jpg")
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "media-body" }, [
                                _c("p", { staticClass: "noti-details" }, [
                                  _c("span", { staticClass: "noti-title" }, [
                                    _vm._v("Tarah Shropshire")
                                  ]),
                                  _vm._v(
                                    " changed the task name\n                          "
                                  ),
                                  _c("span", { staticClass: "noti-title" }, [
                                    _vm._v(
                                      "Appointment booking with payment gateway"
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "noti-time" }, [
                                  _c(
                                    "span",
                                    { staticClass: "notification-time" },
                                    [_vm._v("6 mins ago")]
                                  )
                                ])
                              ])
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "notification-message" },
                        [
                          _c("router-link", { attrs: { to: "/activities" } }, [
                            _c("div", { staticClass: "media" }, [
                              _c("span", { staticClass: "avatar" }, [
                                _c("img", {
                                  attrs: {
                                    alt: "",
                                    src: require("../../assets/profiles/avatar-06.jpg")
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "media-body" }, [
                                _c("p", { staticClass: "noti-details" }, [
                                  _c("span", { staticClass: "noti-title" }, [
                                    _vm._v("Misty Tison")
                                  ]),
                                  _vm._v(" added\n                          "),
                                  _c("span", { staticClass: "noti-title" }, [
                                    _vm._v("Domenic Houston")
                                  ]),
                                  _vm._v(" and\n                          "),
                                  _c("span", { staticClass: "noti-title" }, [
                                    _vm._v("Claire Mapes")
                                  ]),
                                  _vm._v(
                                    "\n                          to project\n                          "
                                  ),
                                  _c("span", { staticClass: "noti-title" }, [
                                    _vm._v("Doctor available module")
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "noti-time" }, [
                                  _c(
                                    "span",
                                    { staticClass: "notification-time" },
                                    [_vm._v("8 mins ago")]
                                  )
                                ])
                              ])
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "notification-message" },
                        [
                          _c("router-link", { attrs: { to: "/activities" } }, [
                            _c("div", { staticClass: "media" }, [
                              _c("span", { staticClass: "avatar" }, [
                                _c("img", {
                                  attrs: {
                                    alt: "",
                                    src: require("../../assets/profiles/avatar-17.jpg")
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "media-body" }, [
                                _c("p", { staticClass: "noti-details" }, [
                                  _c("span", { staticClass: "noti-title" }, [
                                    _vm._v("Rolland Webber")
                                  ]),
                                  _vm._v(
                                    " completed task\n                          "
                                  ),
                                  _c("span", { staticClass: "noti-title" }, [
                                    _vm._v(
                                      "Patient and Doctor video conferencing"
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "noti-time" }, [
                                  _c(
                                    "span",
                                    { staticClass: "notification-time" },
                                    [_vm._v("12 mins ago")]
                                  )
                                ])
                              ])
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "notification-message" },
                        [
                          _c("router-link", { attrs: { to: "/activities" } }, [
                            _c("div", { staticClass: "media" }, [
                              _c("span", { staticClass: "avatar" }, [
                                _c("img", {
                                  attrs: {
                                    alt: "",
                                    src: require("../../assets/profiles/avatar-13.jpg")
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "media-body" }, [
                                _c("p", { staticClass: "noti-details" }, [
                                  _c("span", { staticClass: "noti-title" }, [
                                    _vm._v("Bernardo Galaviz")
                                  ]),
                                  _vm._v(
                                    " added new task\n                          "
                                  ),
                                  _c("span", { staticClass: "noti-title" }, [
                                    _vm._v("Private chat module")
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "noti-time" }, [
                                  _c(
                                    "span",
                                    { staticClass: "notification-time" },
                                    [_vm._v("2 days ago")]
                                  )
                                ])
                              ])
                            ])
                          ])
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "topnav-dropdown-footer" },
                    [
                      _c("router-link", { attrs: { to: "/activities" } }, [
                        _vm._v("View all Notifications")
                      ])
                    ],
                    1
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          false
            ? _c("li", { staticClass: "nav-item dropdown" }, [
                _vm._m(4),
                _vm._v(" "),
                _c("div", { staticClass: "dropdown-menu notifications" }, [
                  _vm._m(5),
                  _vm._v(" "),
                  _c("div", { staticClass: "noti-content" }, [
                    _c("ul", { staticClass: "notification-list" }, [
                      _c(
                        "li",
                        { staticClass: "notification-message" },
                        [
                          _c("router-link", { attrs: { to: "/chat" } }, [
                            _c("div", { staticClass: "list-item" }, [
                              _c("div", { staticClass: "list-left" }, [
                                _c("span", { staticClass: "avatar" }, [
                                  _c("img", {
                                    attrs: {
                                      alt: "",
                                      src: require("../../assets/profiles/avatar-09.jpg")
                                    }
                                  })
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "list-body" }, [
                                _c("span", { staticClass: "message-author" }, [
                                  _vm._v("Richard Miles")
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "message-time" }, [
                                  _vm._v("12:28 AM")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "message-content" }, [
                                  _vm._v(
                                    "Lorem ipsum dolor sit amet, consectetur adipiscing"
                                  )
                                ])
                              ])
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "notification-message" },
                        [
                          _c("router-link", { attrs: { to: "/chat" } }, [
                            _c("div", { staticClass: "list-item" }, [
                              _c("div", { staticClass: "list-left" }, [
                                _c("span", { staticClass: "avatar" }, [
                                  _c("img", {
                                    attrs: {
                                      alt: "",
                                      src: require("../../assets/profiles/avatar-02.jpg")
                                    }
                                  })
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "list-body" }, [
                                _c("span", { staticClass: "message-author" }, [
                                  _vm._v("John Doe")
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "message-time" }, [
                                  _vm._v("6 Mar")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "message-content" }, [
                                  _vm._v(
                                    "Lorem ipsum dolor sit amet, consectetur adipiscing"
                                  )
                                ])
                              ])
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "notification-message" },
                        [
                          _c("router-link", { attrs: { to: "/chat" } }, [
                            _c("div", { staticClass: "list-item" }, [
                              _c("div", { staticClass: "list-left" }, [
                                _c("span", { staticClass: "avatar" }, [
                                  _c("img", {
                                    attrs: {
                                      alt: "",
                                      src: require("../../assets/profiles/avatar-03.jpg")
                                    }
                                  })
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "list-body" }, [
                                _c("span", { staticClass: "message-author" }, [
                                  _vm._v("Tarah Shropshire")
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "message-time" }, [
                                  _vm._v("5 Mar")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "message-content" }, [
                                  _vm._v(
                                    "Lorem ipsum dolor sit amet, consectetur adipiscing"
                                  )
                                ])
                              ])
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "notification-message" },
                        [
                          _c("router-link", { attrs: { to: "/chat" } }, [
                            _c("div", { staticClass: "list-item" }, [
                              _c("div", { staticClass: "list-left" }, [
                                _c("span", { staticClass: "avatar" }, [
                                  _c("img", {
                                    attrs: {
                                      alt: "",
                                      src: require("../../assets/profiles/avatar-05.jpg")
                                    }
                                  })
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "list-body" }, [
                                _c("span", { staticClass: "message-author" }, [
                                  _vm._v("Mike Litorus")
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "message-time" }, [
                                  _vm._v("3 Mar")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "message-content" }, [
                                  _vm._v(
                                    "Lorem ipsum dolor sit amet, consectetur adipiscing"
                                  )
                                ])
                              ])
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "notification-message" },
                        [
                          _c("router-link", { attrs: { to: "/chat" } }, [
                            _c("div", { staticClass: "list-item" }, [
                              _c("div", { staticClass: "list-left" }, [
                                _c("span", { staticClass: "avatar" }, [
                                  _c("img", {
                                    attrs: {
                                      alt: "",
                                      src: require("../../assets/profiles/avatar-08.jpg")
                                    }
                                  })
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "list-body" }, [
                                _c("span", { staticClass: "message-author" }, [
                                  _vm._v("Catherine Manseau")
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "message-time" }, [
                                  _vm._v("27 Feb")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "message-content" }, [
                                  _vm._v(
                                    "Lorem ipsum dolor sit amet, consectetur adipiscing"
                                  )
                                ])
                              ])
                            ])
                          ])
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "topnav-dropdown-footer" },
                    [
                      _c("router-link", { attrs: { to: "/chat" } }, [
                        _vm._v("View all Messages")
                      ])
                    ],
                    1
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("li", { staticClass: "nav-item dropdown has-arrow main-drop" }, [
            _c(
              "a",
              {
                staticClass: "dropdown-toggle nav-link",
                attrs: { href: "#", "data-toggle": "dropdown" }
              },
              [
                _vm._m(6),
                _vm._v(" "),
                _vm.isOwner == true
                  ? _c("span", [_vm._v(_vm._s(_vm.memberSession.email))])
                  : _c("span", [_vm._v(_vm._s(_vm.agentSession.first_name))])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "dropdown-menu" },
              [
                _vm.isOwner == true
                  ? _c(
                      "router-link",
                      {
                        staticClass: "dropdown-item",
                        attrs: { to: "/settings" }
                      },
                      [_vm._v("Settings")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    attrs: { href: "javascript:void(0)" },
                    on: { click: _vm.logout }
                  },
                  [_vm._v("Logout")]
                )
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "dropdown mobile-user-menu" }, [
          _vm._m(7),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dropdown-menu dropdown-menu-right" },
            [
              _vm.isOwner == true
                ? _c(
                    "router-link",
                    {
                      staticClass: "dropdown-item",
                      attrs: { to: "/settings" }
                    },
                    [_vm._v("Settings")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "router-link",
                { staticClass: "dropdown-item", attrs: { to: "/login" } },
                [_vm._v("Logout")]
              )
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      { attrs: { id: "toggle_btn", href: "javascript:void(0);" } },
      [
        _c("span", { staticClass: "bar-icon" }, [
          _c("span"),
          _vm._v(" "),
          _c("span"),
          _vm._v(" "),
          _c("span")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "mobile_btn",
        attrs: { id: "mobile_btn", href: "#sidebar" }
      },
      [_c("i", { staticClass: "fa fa-bars" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "dropdown-toggle nav-link",
        attrs: { href: "#", "data-toggle": "dropdown" }
      },
      [
        _c("i", { staticClass: "fa fa-bell-o" }),
        _vm._v(" "),
        _c("span", { staticClass: "badge badge-pill" }, [_vm._v("3")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "topnav-dropdown-header" }, [
      _c("span", { staticClass: "notification-title" }, [
        _vm._v("Notifications")
      ]),
      _vm._v(" "),
      _c(
        "a",
        { staticClass: "clear-noti", attrs: { href: "javascript:void(0)" } },
        [_vm._v("Clear All")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "dropdown-toggle nav-link",
        attrs: { href: "#", "data-toggle": "dropdown" }
      },
      [
        _c("i", { staticClass: "fa fa-comment-o" }),
        _vm._v(" "),
        _c("span", { staticClass: "badge badge-pill" }, [_vm._v("8")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "topnav-dropdown-header" }, [
      _c("span", { staticClass: "notification-title" }, [_vm._v("Messages")]),
      _vm._v(" "),
      _c(
        "a",
        { staticClass: "clear-noti", attrs: { href: "javascript:void(0)" } },
        [_vm._v("Clear All")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "user-img" }, [
      _c("img", {
        attrs: { src: require("../../assets/profiles/avatar-21.jpg"), alt: "" }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "status online" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "nav-link dropdown-toggle",
        attrs: {
          href: "#",
          "data-toggle": "dropdown",
          "aria-expanded": "false"
        }
      },
      [_c("i", { staticClass: "fa fa-ellipsis-v" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-146e2983", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-146e2983","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/Header.vue
// module id = null
// module chunks = 